module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-26.a4527c47.png";